export const enhancer = el => {
  if (el.querySelector('.rll-youtube-player')) {
    el.classList.add('video-embed--lazy-player');
  }
};
